import secureLocalStorage from "react-secure-storage";
import { mainConfig } from "../../../data/main";
import { getConfig } from "../../../services/getConfig";
import { stdObject } from "../../../data/types/stdObject";
import { sendData } from "../../../services/sendData";
import { directReload } from "../../MainFrame/functions/directReload";
import { getCurrentDate } from "../../../utils/getCurrentDate";
import { recordInitData } from "./recordInitData";

export const enterLogin = async (params: stdObject) => {
  const { dispatch, callback, loginPack = {}, quickLogin = false } = params;
  const {
    setIsLoading = false,
    setMsgType = false,
    setHasSession = false,
  } = loginPack;
  const config = await getConfig();
  mainConfig.url = config.url;

  try {
    const token = secureLocalStorage.getItem("token");
    if (typeof token === "string" && token.length > 10) {
      if (!quickLogin && setIsLoading) {
        setIsLoading(true);
      }
      const responseInfoService: stdObject = await sendData({
        endPoint: "userAllInfo",
        payload: { date: getCurrentDate() },
        url: mainConfig.url,
      });
      // console.log("responseInfoService", responseInfoService);
      if (responseInfoService.success && responseInfoService.status) {
        if (await recordInitData({ initData: responseInfoService, dispatch })) {
          if (quickLogin) {
            secureLocalStorage.removeItem("branch");
            directReload();
          } else {
            setMsgType("");
            setHasSession(true);
          }
        } else {
          console.log("enterLogin recordInitData error");
        }
      } else {
        // console.log(
        //   Object.keys(responseInfoService)
        //     .map((e) => responseInfoService[e])
        //     .join(""),
        // );
      }
      if (!quickLogin && setIsLoading) {
        setIsLoading(false);
      }
    }
  } catch (error) {
    // console.log("login error: ", error);
  }

  if (callback) callback();
};
